import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { UniversalFormDialog } from '@/components/UniversalFormDialog';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import TrademarkRegistrationPage from '@/pages/TrademarkRegistrationPage';
import CopyrightRegistrationPage from '@/pages/CopyrightRegistrationPage';
import CompanyFormationPage from '@/pages/CompanyFormationPage';
import TrademarkSearchPage from '@/pages/TrademarkSearchPage';
import AmazonBrandRegistryPage from '@/pages/AmazonBrandRegistryPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsConditionsPage from '@/pages/TermsConditionsPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function AppContent() {
  const [formDialogOpen, setFormDialogOpen] = useState(false);

  const handleCTAClick = () => {
    setFormDialogOpen(true);
  };

  return (
    <div className="App">
      <ScrollToTop />
      <Header onCTAClick={handleCTAClick} />
      <Routes>
        <Route path="/" element={<HomePage onCTAClick={handleCTAClick} />} />
        <Route path="/trademark-registration" element={<TrademarkRegistrationPage onCTAClick={handleCTAClick} />} />
        <Route path="/copyright-registration" element={<CopyrightRegistrationPage onCTAClick={handleCTAClick} />} />
        <Route path="/company-formation" element={<CompanyFormationPage onCTAClick={handleCTAClick} />} />
        <Route path="/trademark-search" element={<TrademarkSearchPage onCTAClick={handleCTAClick} />} />
        <Route path="/amazon-brand-registry" element={<AmazonBrandRegistryPage onCTAClick={handleCTAClick} />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-conditions" element={<TermsConditionsPage />} />
      </Routes>
      <Footer />
      <UniversalFormDialog open={formDialogOpen} onOpenChange={setFormDialogOpen} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
